import React from 'react'
import { useTranslate } from 'react-admin'
import { TableCell, Typography } from '@mui/material'
import { isStatus } from 'src/components/pages/sales/reservation/helper/isStatus'

interface StatusTableCellProps {
  data: string,
  inlineStatus?: boolean,
  align?: 'left' | 'center' | 'right',
  style?: Object
}

export const StatusTableCell: React.FC<StatusTableCellProps> = ({ data, inlineStatus = false, align, style = {} }) => {
  const translate = useTranslate()
  let status = data ? data : 'UNPAID' // Default to 'UNPAID' if no status is found
  status = status === 'PENDING' ? 'PENDING_BILLING' : status

  return (
    <TableCell style={{ padding: '0px 16px' }} align={align}>
      <Typography
        style={status ?
          { ...isStatus('status', status, true), display: inlineStatus ? 'inline-flex' : 'block', ...style } :
          style
        }>
        {translate(`ra.status.${status}`).includes('.') ? status : translate(`ra.status.${status}`)}
      </Typography>
    </TableCell>
  )
}
